var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',{staticClass:"main"},[_c('router-view',{staticClass:"page"}),_c('CookieConsent')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }